import { createSlice } from "@reduxjs/toolkit";
import api from '../Components/_helpers/api';

export const feSlice = createSlice({
  name: "fe",
  initialState: {
    data: {data:[]},
    currentFilters: {},
    isLoading: true,
    error: "",
  },
  reducers: {
    requestDTEs: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
    },
    requestDTEsSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestDTEsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  },
});

export const { requestDTEs, requestDTEsSuccess, requestDTEsFailure, setError } = feSlice.actions;

//Thunks
export const requestDTEsAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestDTEs(filters));

  api.post('/FE/DTE', payload).then((data) => {
    dispatch(requestDTEsSuccess(data.data));
  }).catch(e => {
    console.log(e);
    dispatch(requestDTEsFailure(e));
  });
};

//Selector
export const selectData = (state) => state.fe.data;
export const selectIsLoading = (state) => state.fe.isLoading;
export const selectError = (state) => state.fe.error;
export const selectCurrentFilters = (state) => state.fe.currentFilters;

export default feSlice.reducer;
